import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZAsset = z.object({
  id: z.string(),
  name: z.string(),
  serial_number: z.string()
})

const ZData = z.object({
  total_count: z.number(),
  assets: ZAsset.array()

})

const ZApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZData),
  error: z.boolean()
})

export type Asset = z.infer<typeof ZAsset>
export type AssetList = z.infer<typeof ZData>

export async function getAssignedAssetList (
  templateId: string,
  page: number,
  size: number,
  onSuccess: (assetList: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/commands/configuration/assigned/asset/${templateId}?page=${page}&size=${size}`
  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          // istanbul ignore else
          if (parseResponse.data.data !== null && parseResponse.data.data !== undefined) {
            onSuccess(parseResponse.data.data, parseResponse.data.http_status)
          } else {
            onFailure(parseResponse.data.error, parseResponse.data.http_status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else {
        onFailure(response.statusText, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(error.message, error.response.status)
      }
    })
}
